<style lang="scss" scoped>
.promotion {
	@include flex-top;
	&__left {
		width: 74%;
		margin-right: 1%;
		img {
			width: 100%;
			display: block;
			border-radius: 5px;
			overflow: hidden;
			-webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
			box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
		}
	}
	&__right {
		width: 25%;
		display: flex;
		flex-direction: column;
		-webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
		box-shadow: 0 2px 0 rgba(0, 0, 0, 0.1);
		border-radius: 5px;
		overflow: hidden;
		img {
			width: 100%;
			display: block;
		}
	}
}
</style>


<template lang="pug">
    .promotion(v-if="!$route.query.search").hidden-sm-and-down
        .promotion__left
            router-link(:to="{name: 'application', params: { slug: linkMain.slug }}")
                img(:src="linkMain.image")
        .promotion__right
            .promotion__app(v-for="link in linksRight", :key="link.slug")
                router-link(:to="{name: 'application', params: { slug: link.slug }}")
                    img(:src="link.image")
</template>

<script>
export default {
	data() {
		return {
			linkMain: {
				name: "Class Dojo",
				slug: "class-dojo",
				image: require("@/assets/examples/class-dojo.png")
			},
			linksRight: [
				{
					name: "Care Monkey",
					slug: "care-monkey",
					image: require("@/assets/examples/caremonkey-banner.png")
				},
				{
					name: "Sum Dog",
					slug: "sumdog",
					image: require("@/assets/examples/sumdog.png")
				},
				{
					name: "Education City",
					slug: "education-city",
					image: require("@/assets/examples/education-city.png")
				}
			]
		};
	}
};
</script>